import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';

export const useLiveGamesOnSocketReconnected = () => {
    const dispatch = useDispatch();

    return useCallback((): void => {
        dispatch(actions.updateReconnectionStatus(true));
        dispatch(actions.updateReconnectionStatus(false));

        log('log', '[LIVE | Portal] WebSocket reconnected');
    }, [dispatch]);
};
